import { useMutation } from '@tanstack/react-query';
import { del } from '../libs';

interface Params {
  id: string;
}

/**
 * 코치 - 직접 일정 삭제
 * @returns
 */
export function useDeleteScheduleCoachPersonalMutation() {
  return useMutation(({ id }: Params) =>
    del(`/schedules/coach/personal/${id}`)
  );
}
